import { createContext, useContext, useEffect, useState } from "react";
import { useClients } from "./Clients";

const ClientContext = createContext(null);

export const ClientContextProvider = ({
  children,
  clientId,
  isCompanySettings = false,
}) => {
  const { getClientById, updateClient, getCompanySettings } = useClients();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(false);

  const getClient = async () => {
    let newClient = null;
    setLoading(true);
    if (isCompanySettings) {
      newClient = await getCompanySettings();
    } else {
      newClient = await getClientById(clientId);
    }
    setClient(newClient);
    setLoading(false);
  };

  const update = async (body) => {
    setLoading(true);
    const res = await updateClient(body.Id, body);
    setClient(res.data);
    setLoading(false);
    return res;
  };

  useEffect(() => {
    getClient();
  }, [clientId]);

  return (
    <ClientContext.Provider
      value={{
        client,
        update,
        loading,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = () => useContext(ClientContext);
